<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Tax rates')"
          :description="$t('From Here You Can Control Tax rate Units')"
        />
        <indexTable
          :searchText="$t('Search For A Tax')"
          :emptyTableText="$t('There are no tax rates')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="true"
          :cloumns="[
            {
              column: 'name',
              title: $t('Name the tax rate'),
              type: 'text',
              sort: true
            },
            {
              column: 'rate',
              title: $t('Tax rate'),
              type: 'text',
              sort: true,
              after: '%'
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: true },
                { name: 'delete', role: true }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/taxes'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
